import React from "react";
import { Button } from "react-bootstrap";
import { Trans } from "react-i18next";

import "../styles/components/TabComponent.scss";
interface TabComponentType {
  tabList: { adminRoute: string; title: string; translationKey: string }[];
  handleTabChange: (userType: string) => void;
  activeValue: string;
}

const TabComponent = ({
  tabList,
  handleTabChange,
  activeValue,
}: TabComponentType) => {
  return (
    <div className="bg-light-gray">
      <ul className="tabComponentList container">
        {tabList.map((tabValue) => {
          return (
            <li
              key={tabValue.title}
              className="tabComponentItem"
              onClick={() => handleTabChange(tabValue.adminRoute)}
            >
              <button
                className={
                  activeValue === tabValue.adminRoute
                    ? "tabComponentButton tabButtonActive"
                    : "tabComponentButton"
                }
              >
                <Trans i18nKey={tabValue.translationKey} />
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default TabComponent;
